import { logger } from '@/shared/utils';
import { useEffect, useRef } from 'react';
import { disconnect, closeConnection } from '@/infrastructure/sdk';

/**
 * Custom hook to manage SDK socket connection based on tab activity
 * Disconnects when tab becomes inactive, reconnects when tab becomes active
 *
 * @param {boolean} isActive - Whether this tab is currently active
 * @param {string} tabId - The unique identifier for this tab
 */
export const useSocketManager = (isActive, tabId) => {
   const previousActiveState = useRef(isActive);

   useEffect(() => {
      // Only react to changes in active state
      if (previousActiveState.current === isActive) {
         return;
      }

      previousActiveState.current = isActive;

      const handleSocketConnection = async () => {
         if (!isActive) {
            // Tab became inactive - disconnect socket
            try {
               if (disconnect) {
                  await disconnect();
               } else if (closeConnection) {
                  await closeConnection();
               }
            } catch (error) {
               logger.error(`[UseHere][${tabId}] Error disconnecting socket:`, error);
            }
         }
      };

      handleSocketConnection();
   }, [isActive, tabId]);
};
